import { render } from "./BoxShow.vue?vue&type=template&id=6fbe333a&scoped=true"
import script from "./BoxShow.vue?vue&type=script&lang=js"
export * from "./BoxShow.vue?vue&type=script&lang=js"

import "./BoxShow.vue?vue&type=style&index=0&id=6fbe333a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fbe333a"]])

export default __exports__